/**
 *  @fileOverview Cookie handler utility
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

class CookieHandling {
  createCookie(name, value, days) {
    const date = new Date();
    let expires = '';

    if (days) {
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires= ${date.toUTCString()};`;
    }
    document.cookie = `${name} = ${value} ${expires}; path=/`;
  }

  eraseCookie(name) {
    this.createCookie(name, '', -1);
  }

  getCookie(name) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(`${name}=`);

      if (start !== -1) {
        start = start + name.length + 1;
        let end = document.cookie.indexOf(';', start);

        if (end === -1) {
          end = document.cookie.length;
        }
        return decodeURI(document.cookie.substring(start, end));
      }
    }
    return '';
  }

  checkCookie(name) {
    const cookieName = this.getCookie(name);
    return cookieName !== null && cookieName !== '';
  }
}

export const cookieHandling = new CookieHandling();



// WEBPACK FOOTER //
// ./src/js/utils/cookie-handling.js